module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {}, [_c('h2', {
    staticClass: "bold mb-5"
  }, [_vm._v("Account")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.perfil.avatar === null) ? _c('img', {
    staticClass: "rounded-circle mr-5",
    attrs: {
      "src": require("../../assets/images/image-preview.svg")
    }
  }) : _c('img', {
    staticClass: "rounded-circle mr-5",
    attrs: {
      "src": _vm.perfil.avatar,
      "width": "200px",
      "height": "150px"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "bold mb-2"
  }, [_vm._v(_vm._s(_vm.perfil.nombre))]), _vm._v(" "), _c('p', {
    staticClass: "m-0 text-muted"
  }, [_vm._v(_vm._s(_vm.perfil.apellido))]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-primary",
    class: _vm.perfil.store === 2 ? 'bg-danger' : ' bg-primary'
  }, [_vm._v("\n          " + _vm._s(_vm.perfil.store === 2 ? "Envios" : " Sendi"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 1 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 1
      }
    }
  }, [_vm._v("\n      Perfil\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 2 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 2
      }
    }
  }, [_vm._v("\n      Saldo\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 3 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 3
      }
    }
  }, [_vm._v("\n      Pedidos\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 4 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 4
      }
    }
  }, [_vm._v("\n      Direcciones\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 5 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 5
      }
    }
  }, [_vm._v("\n      Credenciales\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 6 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 6
      }
    }
  }, [_vm._v("\n      Cotizaciones\n    ")]), _vm._v(" "), (_vm.perfil.store === 2) ? _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 7 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 7
      }
    }
  }, [_vm._v("\n      Viajes\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 8 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 8
      }
    }
  }, [_vm._v("\n      Influencer\n    ")])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), (_vm.section === 2) ? _c('button', {
    staticClass: "btn d-block ml-auto mb-4 btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('modal-operacion')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n    Agregar operación\n  ")]) : _vm._e(), _vm._v(" "), (_vm.section === 1) ? _c('PerfilComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser,
      "direction": _vm.direction,
      "perfil": _vm.perfil
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 2) ? _c('SaldoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 3) ? _c('PedidoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 4) ? _c('DirectionComponent', {
    attrs: {
      "perfil": _vm.perfil,
      "credential": _vm.credential
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 5) ? _c('CredentialComponent', {
    attrs: {
      "credential": _vm.credential,
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 6) ? _c('CotizacionComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 7) ? _c('ViajeComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser,
      "travelSquad": _vm.travel_squad
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 8) ? _c('button', {
    staticClass: "d-block mb-4 ml-auto",
    class: _vm.influencerFlag === 1 ? 'btn btn-danger' : 'btn btn-primary',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeFlagInfluencer(_vm.influencerFlag === 1 ? 0 : 1)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.influencerFlag === 1 ? "Desactivar Influencer" : "Activar Influencer") + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.section === 8) ? _c('CodigoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-operacion"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addSaldoUser()
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Agregar operación")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-operacion')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Titulo de la operación")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.title),
      expression: "saldo.title"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción de la operación")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.description),
      expression: "saldo.description"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-8 pl-0"
  }, [_c('label', [_vm._v("Monto de la operacion")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.monto),
      expression: "saldo.monto"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.monto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "monto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar operación\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702ad3cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User.vue
// module id = 1895
// module chunks = 1